export default "__VITE_ASSET__t7eFJZXA__"